import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, List, ListItem, Typography } from '@mui/material';
var ROI_HORIZON_STRINGS = appStrings.modules.charts.returnOnInvestment.roiHorizonModal;
export var ROIHorizonModalContent = function () {
    return (_jsxs(Box, { sx: containerSx, children: [_jsxs(Box, { sx: sectionSx, children: [_jsx(Typography, { variant: "text-sm-bold", children: ROI_HORIZON_STRINGS.whatItIs.title }), ROI_HORIZON_STRINGS.whatItIs.paragraphs.map(function (paragraph, index) { return (_jsx(Typography, { variant: "text-sm-regular", sx: paragraphSx, children: paragraph }, index)); })] }), _jsxs(Box, { sx: sectionSx, children: [_jsx(Typography, { variant: "text-sm-bold", children: ROI_HORIZON_STRINGS.whyItMatters.title }), ROI_HORIZON_STRINGS.whyItMatters.paragraphs.map(function (paragraph, index) { return (_jsx(Typography, { variant: "text-sm-regular", sx: paragraphSx, children: paragraph }, index)); }), _jsx(List, { sx: bulletListSx, children: ROI_HORIZON_STRINGS.whyItMatters.bulletPoints.map(function (point, index) { return (_jsx(ListItem, { sx: bulletItemSx, children: _jsx(Typography, { variant: "text-sm-regular", children: point }) }, index)); }) }), _jsx(Typography, { variant: "text-sm-regular", sx: paragraphSx, children: ROI_HORIZON_STRINGS.whyItMatters.additionalParagraph })] }), _jsxs(Box, { sx: sectionSx, children: [_jsx(Typography, { variant: "text-sm-bold", children: ROI_HORIZON_STRINGS.howItIsCalculated.title }), ROI_HORIZON_STRINGS.howItIsCalculated.paragraphs.map(function (paragraph, index) { return (_jsx(Typography, { variant: "text-sm-regular", sx: paragraphSx, children: paragraph }, index)); }), _jsx(List, { sx: bulletListSx, children: ROI_HORIZON_STRINGS.howItIsCalculated.bulletPoints.map(function (point, index) { return (_jsx(ListItem, { sx: bulletItemSx, children: _jsx(Typography, { variant: "text-sm-regular", children: point }) }, index)); }) }), _jsx(Typography, { variant: "text-sm-regular", sx: paragraphSx, children: ROI_HORIZON_STRINGS.howItIsCalculated.conclusion }), _jsx(Typography, { variant: "text-sm-regular", sx: paragraphSx, children: ROI_HORIZON_STRINGS.howItIsCalculated.source })] })] }));
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-lg'],
    });
};
var sectionSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xs'],
    });
};
var paragraphSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Colors/Text/text-secondary'],
    });
};
var bulletListSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        margin: 0,
        paddingLeft: backrs.spacing['spacing-2xl'],
        listStyleType: 'disc',
    });
};
var bulletItemSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'list-item',
        padding: 0,
        paddingLeft: backrs.spacing['spacing-xs'],
        color: backrs.colors['Colors/Text/text-secondary'],
    });
};
